<template>
 <div class="page-wrapper">
    <div class="container-fluid p-0">
        <!-- <div class="card m-5">
            <img class="card-img-overlay" src="../assets/images/conexAI.jpeg">
        </div> -->
        <div class="authentication-main">
        <div class="row">
            <div class="col-md-12">
                <div class="auth-innerright">
                    <!-- <div class="authentication-box">
                        <img alt="" src="../assets/images/conexAI.jpeg" style="width: 100%; height: 100%;">
                    </div> -->
                    <div class="authentication-box">
                        <div id="recaptcha-container"></div>
                        <div class="text-center"><img alt="" :src="require('../assets/images/conex-logo.png')" @dblclick="swRegister"></div>
                        <div class="card mt-4">
                            <div class="card-body">
                                 <div style="text-align: right">
                                    <LocalSwitcher />  
                                </div>
                                <div class="text-center">
                                    <h4>{{ $t('loginPage.login') }}</h4>
   
                                    <h6 class="text-center text-info ">{{ $t('loginPage.enterEmailPwd') }} </h6>
                                </div>
                                <form class="theme-form">
                                <div class="form-group">
                                    <label class="col-form-label text-primary f-w-600 pt-0">{{ $t('loginPage.yourEmail') }}</label>
                                    <input v-model="email" class="form-control" type="email" :placeholder="$t('loginPage.enterEmailAddress')">
                                </div>
                                <!-- <div class="form-group">
                                    <label class="col-form-label  text-primary f-w-600">{{ $t('loginPage.pwd') }}</label>
                                    <input v-model="password" :type="type" class="form-control" name="loginpassword" :placeholder="$t('loginPage.enterPwd')">
                                    <div class="show-hide"><span class="show" @click="showPassword"></span></div>
                                </div> -->
                                <div v-show="showPwdInput" >
                                    <label class="col-form-label text-primary f-w-600">{{ $t('loginPage.pwd') }}</label>
                                    <div class="d-flex flex-row justify-content-start">
                                        <div class="col-sm-6"> 
                                            <input v-model="password" :type="type" class="form-control" name="loginpassword" :placeholder="$t('loginPage.enterPwd')">
                                        </div>
                                        <div class="col-sm-2"> 
                                            <feather @click="showPassword" class="text-dark mt-2" :type="iconType"  size="20"></feather>   
                                        </div>
                                    </div>
                                </div>
                                <div  class="mt-0 mb-5" style="text-align: right" > 
                                    <span class="text-info text-underline mt-3"  @click="goForgotPassword"> {{ $t('loginPage.forgotPassword') }}</span>
                                </div>
                                <!-- <div class="checkbox p-0">
                                    <input id="checkbox1" type="checkbox">
                                    <label for="checkbox1">Remember me</label>
                                </div> -->
                                <div class="form-group form-row mt-3 mb-0">
                                    <button class="btn btn-primary btn-block" style="font-size: 18px;" type="button" @click="doLogin">{{ $t('loginPage.signIn') }}</button>
                                </div>
                                    <div class="form-group form-row mt-3 mb-0">
                                    <!-- <button class="btn btn-secondary btn-block" type="button" @click="">Login With
                                        Auth0
                                    </button> -->
                                    <button class="btn btn-secondary btn-block" style="font-size: 18px;" type="button"  v-show="registerBTN" @click="goRegister">{{ $t('loginPage.register') }}</button>
                                </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
 </div>
</template>
<script>
import {  onAuthStateChanged, signInWithEmailAndPassword, RecaptchaVerifier } from "firebase/auth";
import {authUser, userInfoByUid} from "../firebase"
import LocalSwitcher from "../components/localSwitcher.vue"
export default {
    components: { LocalSwitcher },
    data() {
    return{ 
        user: null, // This will hold the authenticated user object or null
        loadingAuth: true,// To indicate if we're still checking the auth state on load
        showPwdInput : true,
        type: 'password',
        iconType: 'eye-off',
        email: '',
        password: '',
        registerBTN : false
    }
   },
    mounted() {

        const unsubscribe = onAuthStateChanged(authUser, (user) => {
            //console.log("Auth state changed. User:", user ? user.uid : "null");
            this.user = user; // Update the user data property
            this.loadingAuth = false; // Authentication state check is complete

            if (user) {
                // User is signed in (either just logged in, or found via persistent session)
                // console.log(`User is signed in with UID: ${user.uid}`);
                // Redirect or show content for logged-in users
                // Example: this.$router.push('/dashboard');
            // this.$toasted.show(this.$t('loginPage.signedIn') + `${ user.email || user.phoneNumber}`, {theme: 'bubble', type: 'info' , position: 'bottom-center', duration: 20000});
                let userCat = localStorage.getItem('userCat')
                // console.log(`user was signed in , userCat : ${userCat}`);
                switch (userCat) {
                    case 'agent':
                        setTimeout(function () {
                            window.location.href='/dashboard/homePageAgent'  
                        },500)                                         
                        break;   
                    case 'conex':
                        setTimeout(function () {
                            window.location.href='/dashboard/matchingAdmin'  
                        },500)                                         
                        break;
                    case 'cert':
                        setTimeout(function () {
                            window.location.href='/'  
                        },500)                                         
                        break;
                    case 'trans':
                        setTimeout(function () {
                            window.location.href='/process/transport'  
                        },500)                                         
                        break;
                    case 'driver':
                        setTimeout(function () {
                            window.location.href='/process/approvedTrans'  
                        },500)                                         
                        break;
                    case 'logist':
                        setTimeout(function () {
                            window.location.href='/dashboard/homePage'  
                        },500)                                         
                        break;    
                    default:
                        break;
                }      
            } else {
                // User is signed out (either explicitly, or no persistent session found)
                console.log("No user is signed in.");
                // Redirect or show content for logged-out users (e.g., login page)
                // Example: this.$router.push('/login');
            }
        });

        // Important for SPAs: Clean up the listener when the component is destroyed
        this.$once('hook:beforeDestroy', () => {
            console.log("Detaching onAuthStateChanged listener.");
            unsubscribe();
        });
        // Check if authUser is actually defined and is a valid Auth instance
        if (!authUser) {
                console.error("Firebase Auth instance is not initialized or defined!");
                return; // Prevent the RecaptchaVerifier call
            }
        this.recaptchaVerifier = new RecaptchaVerifier( authUser,'recaptcha-container', {
            size: 'invisible',
            callback: (response) => {
                // reCAPTCHA solved, allow signInWithPhoneNumber.
                // this.signInWithMb();
                console.log(`signInPhoneNumber : ${JSON.stringify(response)}`)
            },
        });
        // console.log(`this.recaptchaVerifier => ${JSON.stringify( this.recaptchaVerifier , null , 2)}`)
    },
    methods: {
            showPassword: function() {
                if (this.type === 'password') {
                this.type = 'text';
                this.iconType = 'eye'
                } else {
                this.type = 'password';
                this.iconType = 'eye-off'
                }
            },
            doLogin() {
                let msg = 'completed'
                let pattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g
                if (this.email ===''){
                    msg = this.$t('loginPage.enterEmailMsg')
                } else if (!pattern.test(this.email)){
                    msg = this.$t('loginPage.emailFormatMsg')
                } else if (this.password ===''){
                    msg = this.$t('loginPage.enterPwdMsg')
                } else if (this.password.length < 8){
                    msg = this.$t('loginPage.pwd8UpMsg')
                }  
                if (msg === 'completed'){
                    signInWithEmailAndPassword(authUser, this.email, this.password)
                    .then((userCredential) => {
                        if (userCredential.user) {
                            userInfoByUid(userCredential.user.uid, (res)=>{
                                console.log(`User info=> ${JSON.stringify(res , null ,2)}`)
                                if (!res) {
                                    this.$toasted.show(this.$t('loginPage.suspendUser') , {theme: 'bubble',   position: 'bottom-center',   type: 'error', duration: 10000});
                                } else {
                                    this.$toasted.show(this.$t('loginPage.successLogin') + this.email, {theme: 'bubble', type: 'success' , position: 'bottom-center', duration: 10000});
                                    localStorage.setItem('user', res.email)
                                    localStorage.setItem('userId', res.userId)
                                    localStorage.setItem('userCat', res.userCat)
                                    localStorage.setItem('compId', res.compId)
                                    switch (res.userCat) {
                                        case 'agent':
                                            setTimeout(function () {
                                                window.location.href='/dashboard/homePageAgent'  
                                            },500)                                         
                                            break;
                                        case 'conex':
                                            setTimeout(function () {
                                                window.location.href='/dashboard/matchingAdmin'  
                                            },500)                                         
                                            break;
                                        case 'cert':
                                            setTimeout(function () {
                                                window.location.href='/'  
                                            },500)                                         
                                            break;
                                        case 'trans':
                                            setTimeout(function () {
                                                window.location.href='/process/transport'  
                                            },500)                                         
                                            break;
                                        case 'driver':
                                            setTimeout(function () {
                                                window.location.href='/process/approvedTrans'  
                                            },500)                                         
                                            break;
                                        case 'logist':
                                            setTimeout(function () {
                                                window.location.href='/dashboard/homePage'  
                                            },500)                                         
                                            break;    
                                        default:
                                            break;
                                    }                                    
                                }
                            })
                        
                            // setTimeout(function () {
                            //    window.location.href='/'  
                            // },500)
                            // this.$router.push('/');                                     
                        } else {
                            this.$toasted.show(this.$t('loginPage.failLogin') , {theme: 'bubble',   position: 'bottom-center',   type: 'error', duration: 5000});
                        }
                    })
                    .catch((error) => {
                        this.$toasted.show(`${this.$t('loginPage.failLogin')} : ${error.message}`, {theme: 'bubble',   position: 'bottom-center',   type: 'error', duration: 5000});
                    });                                                 
                }else{
                    this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
                }
            },
            goRegister() {
                this.$router.push('/auth/register');
            },
            swRegister() {
                if (this.registerBTN == false) {
                    this.registerBTN = true;
                } else {
                    this.registerBTN = false;
                }
            },
            goForgotPassword(){
                this.$router.push('/auth/forgotPassword');
            }

    }
}
</script>